var fileDownload = require("js-file-download");

import Vue from "vue";
const vm = Vue.prototype;

import $i18n from "../i18n";

import checkApp from "../service/check-application.js";

const statuses = ["", "/not_paid", "/half_paid", "/paid"];

export const state = () => ({
  applications: [],
  count: [],
  application: checkApp(),
});

export const mutations = {
  SET_APPLICATIONS(state, payload) {
    state.applications = vm.$toArray(payload);
  },

  SET_COUNT(state, payload) {
    state.count = payload || {};
  },

  SET_BY_ID(state, payload) {
    state.application = checkApp(payload);
  },
};

export const actions = {
  async INIT_APPLICATIONS({ commit }, options) {
    const { itemsPerPage, sortBy = [], sortDesc = [] } = options;

    const page = Number(options.page - 1) || 0;
    const sortField = sortBy.length ? sortBy[0] : "";
    const sortOrder = sortDesc.length && sortDesc[0] ? "desc" : "asc";

    // const senc = search ? encodeURI(search) : null;

    const query = `?page=${page}&size=${itemsPerPage}&sortField=${sortField}&sortOrder=${sortOrder}`;
    let totalItemsCount = 0;

    const status = statuses[options.status] || "";

    const data = await vm.$axios.$get(`admin/masters2024${status}${query}`);

    if (data) {
      commit("SET_APPLICATIONS", data.content);

      totalItemsCount = data.totalElements;
    }

    return totalItemsCount;
  },

  async EXPORT_EXCEL(ctx, options) {
    const status = statuses[options.status] || "";

    const res = await vm.$axios.$getBlob2(`admin/masters2024/export${status}`);

    if (res?.data) {
      const ss = `${status || ""}`.replace("/", "");
      const file_name = `${ss?.trim() ? ss : "all"}_contracts`;
      const date = new Date().toISOString().substr(0, 10);
      fileDownload(res.data, `${file_name}_${date}.xlsx`);
    }

    return true;
  },

  async EXPORT_EXCEL_PAID() {
    const status = "/passed";
    const res = await vm.$axios.$getBlob2(`admin/application/export${status}`);

    if (res?.data) {
      const ss = `${status || ""}`.replace("/", "");
      const file_name = `${ss?.trim() ? ss : "all"}_application`;
      const date = new Date().toISOString().substr(0, 10);
      fileDownload(res.data, `${file_name}_${date}.xlsx`);
    }

    return true;
  },

  async INIT_COUNT({ commit }) {
    const data = await vm.$axios.$get(`admin/masters2024/count`);
    commit("SET_COUNT", data);
    return data != null;
  },

  async PAID_APPLICATION({ dispatch }, { id }) {
    if (id) {
      const res = await vm.$axios.$post(`admin/masters2024/${id}/paid`);

      const status = res != null;
      if (status) {
        dispatch(
          "SET_SNACKBAR",
          {
            text: $i18n.t("Success"),
            color: "success",
          },
          { root: true }
        );
      }
      return status;
    } else return null;
  },

  async REJECT_APPLICATION({ dispatch }, { id, reviews }) {
    if (id) {
      const res = await vm.$axios.$post(
        `admin/application/${id}/rejects`,
        reviews
      );

      const status = res != null;
      if (status) {
        dispatch(
          "SET_SNACKBAR",
          {
            text: $i18n.t("Success"),
            color: "success",
          },
          { root: true }
        );
      }
      return status;
    } else return null;
  },

  async DELETE_APPLICATION({ dispatch }, { id }) {
    if (id) {
      const res = await vm.$axios.$delete(`admin/masters2024/${id}`);

      const status = res != null;
      if (status) {
        dispatch(
          "SET_SNACKBAR",
          {
            text: $i18n.t("Success"),
            color: "success",
          },
          { root: true }
        );
      }
      return status;
    } else return null;
  },

  async INIT_BY_ID({ commit }, { id }) {
    if (id) {
      const data = await vm.$axios.$get(`admin/masters2024/open/${id}`);
      if (data) data.id = Number(id);

      commit("SET_BY_ID", data);
      return data != null;
    }
  },
};

export const getters = {
  GET_APPLICATIONS: (state) => state.applications,
  GET_COUNT: (state) => state.count,
  GET_APPLICATION: (state) => state.application,
};
